<template>

    <div class="col-lg-5 col-sm-6">
        <div class="card  mb-4">
            <div class="card-body p-3">
                <div class="row">
                    <div class="col-8">
                        <div class="numbers">
                            <p class="text-sm mb-0 text-capitalize font-weight-bold">Today's Money</p>
                            <h5 class="font-weight-bolder mb-0">
                                $53,000
                                <span class="text-success text-sm font-weight-bolder">+55%</span>
                            </h5>
                        </div>
                    </div>
                    <div class="col-4 text-end">
                        <div :class="'icon icon-shape bg-gradient-' + setup.app_color + ' shadow text-center border-radius-md'">
                            <i class="ni ni-money-coins text-lg opacity-10" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card ">
            <div class="card-body p-3">
                <div class="row">
                    <div class="col-8">
                        <div class="numbers">
                            <p class="text-sm mb-0 text-capitalize font-weight-bold">Today's Users</p>
                            <h5 class="font-weight-bolder mb-0">
                                2,300
                                <span class="text-success text-sm font-weight-bolder">+3%</span>
                            </h5>
                        </div>
                    </div>
                    <div class="col-4 text-end">
                        <div :class="'icon icon-shape bg-gradient-' + setup.app_color + ' shadow text-center border-radius-md'">
                            <i class="ni ni-world text-lg opacity-10" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-5 col-sm-6 mt-sm-0 mt-4">
        <div class="card  mb-4">
            <div class="card-body p-3">
                <div class="row">
                    <div class="col-8">
                        <div class="numbers">
                            <p class="text-sm mb-0 text-capitalize font-weight-bold">New Clients</p>
                            <h5 class="font-weight-bolder mb-0">
                                +3,462
                                <span class="text-danger text-sm font-weight-bolder">-2%</span>
                            </h5>
                        </div>
                    </div>
                    <div class="col-4 text-end">
                        <div :class="'icon icon-shape bg-gradient-' + setup.app_color + ' shadow text-center border-radius-md'">
                            <i class="ni ni-paper-diploma text-lg opacity-10" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card ">
            <div class="card-body p-3">
                <div class="row">
                    <div class="col-8">
                        <div class="numbers">
                            <p class="text-sm mb-0 text-capitalize font-weight-bold">Sales</p>
                            <h5 class="font-weight-bolder mb-0">
                                $103,430
                                <span class="text-success text-sm font-weight-bolder">+5%</span>
                            </h5>
                        </div>
                    </div>
                    <div class="col-4 text-end">
                        <div :class="'icon icon-shape bg-gradient-' + setup.app_color + ' shadow text-center border-radius-md'">
                            <i class="ni ni-cart text-lg opacity-10" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import {mapGetters} from "vuex";

    export default {
        name: "SmallBoxesComponent",
        components: {

            // ...

        },
        created() {

            // ...

        },
        mounted() {

            // ...

        },
        data: function () {
            return {

                // ...

            }
        },
        computed: {

            ...mapGetters({

                setup: 'setup/getSetup',
            })

        },
        // watch: {
        //
        //     // ...
        //
        // },
        methods: {

            // ...

        }
    }

</script>

<style scoped lang="scss">

    // ...

</style>